import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Tooltip from '#components/m/Tooltip'
import Text from './Text'
import Archived from '#components/svg/icons/Archived'
import Checkbox from '#components/a/form/Checkbox'

export default function ArchivedTask({task: {text}}) {
  const renderArchiveToolTip = () => (
    <Tooltip trigger={<Archived />} modifier="dark small" placement="bottom" triggerAction="hover">
      <Text modifier="in-tooltip" text={i18n.t('status_aufgabe_archived')} />
    </Tooltip>
  )

  return (
    <div className="task task--archived">
      <Checkbox modifier="disabled" disabledState checked={false} labelText={text} />
      {renderArchiveToolTip()}
    </div>
  )
}

ArchivedTask.propTypes = {
  task: PropTypes.shape({
    text: PropTypes.string,
  }).isRequired,
}
